module.exports = __webpack_public_path__ + "img/MoreHeroesNeeded_Progress_Bar_x2.0093bd9b.png";